import { wizardModes } from 'Models/Enums';
import React from 'react';
import { TransactionPricingResult } from 'Services/Api/_HumanWritten/PricingService/PricingResult';
import { stringNotEmpty } from 'Util/TypeGuards';
import { RenderAddServiceFeeModal } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/Modals/AddFeeModal';
import { getBookingTypesFromTransactionPricingHelper } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Cart/BookingTypeHelpers';
import { tripSummaryLocationType } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Cart/TripBookingSummaryCard';
import { Button } from 'Views/Components/Button/Button';
import { appConfigStore } from 'Models/AppConfigStore';
import { store } from 'Models/Store';

export interface AddServiceFeeButtonProps {
	transactionPricingResults?: TransactionPricingResult;
	tripSummaryLocation: tripSummaryLocationType;
	wizardMode: wizardModes;
	transactionId?: string;
	refetch?: boolean;
	setRefetch?: (refetch: boolean) => void;
}

export function AddServiceFeeButton({
	transactionPricingResults,
	tripSummaryLocation,
	wizardMode,
	transactionId,
	refetch,
	setRefetch,
}: AddServiceFeeButtonProps) {
	// Offer putting the check-in forfeit fee back only when there is a removal to undo: the feature is on,
	// this is a check-in, and no forfeit line is on the transaction any more. Gated on the capability
	// that can take it off again — restore-check-in-forfeit-fee carries [RequirePermission(WaiveFees)]
	// — so nobody is offered a charge they could not then remove.
	const forfeitFeeIsOnTransaction = (transactionPricingResults?.linkedBookings ?? []).some(
		x =>
			x.departureBooking?.priceLineItems?.some(y => y.key === 'CheckInForfeitFee') ||
			x.returnBooking?.priceLineItems?.some(y => y.key === 'CheckInForfeitFee'),
	);
	const canRestoreCheckInForfeitFee =
		store.can('WaiveFees') &&
		tripSummaryLocation === 'check-in' &&
		!appConfigStore.refundsEnabledInCheckIn &&
		!forfeitFeeIsOnTransaction;

	return (
		<Button
			className="override-total-amount-button"
			buttonProps={{ 'data-test-id': 'add-service-fee-button' } as any}
			onClick={() => {
				RenderAddServiceFeeModal(
					transactionPricingResults?.linkedBookings ?? [],
					tripSummaryLocation,
					wizardMode,
					transactionPricingResults?.lines
						?.filter(x => x.key === 'ServiceFee')
						?.filter(x => stringNotEmpty(x.feeOptionId))
						?.map(x => x.feeOptionId ?? '') ?? [],
					tripSummaryLocation === 'check-in',
					transactionId,
					getBookingTypesFromTransactionPricingHelper(
						transactionPricingResults?.linkedBookings?.map(x => x.departureBooking),
					),
					canRestoreCheckInForfeitFee,
				)
					.then(async () => {
						if (setRefetch) {
							setRefetch(!refetch);
						}
					})
					.catch(() => {}); // do nothing
			}}
			newStyles
		>
			Add service fee
		</Button>
	);
}
